module.exports = __webpack_public_path__ + "010fcab08c5b42e0530fd72c821d13d6.png";